import { Layout, Section } from 'layout';
import { PocAgentCallsListScreen } from 'pages/poc-agent-calls/screens/poc-agent-calls-list-screen';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

const PocAgentCallsPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
          <Route path={`${match.url}/list`} component={PocAgentCallsListScreen} />
          {/* <Route path={`${match.url}/details/:code`} component={PocAgentCallsDetailsScreen} /> */}
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default PocAgentCallsPage;
